import styled from 'styled-components';
import { bordaArredondar, espacamento } from '../../styles/constants/sizes';

export const JanelaContato = styled.div`
  position: absolute;
  overflow: visible;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 4px;
  padding: ${espacamento.medio}px;
  box-shadow: 0 5px 30px 0 rgb(0 0 0 / 50%);
  display: flex;
  width: max-content;
  max-width: 95%;
  flex-direction: column;

  div {
    max-height: 90vh;
  }

  iframe {
    max-width: 100%;
    max-height: 80vh;
  }

  img {
    object-fit: contain;
    overflow: hidden;
    max-height: 75vh;
  }

  @media screen and (min-width: 1000px) {
    min-width: 600px;
    max-width: 60em;
  }
`;

export const TituloContato = styled.h4`
    font-size: 1.1em;
    border-bottom: 1px solid #dededd;
    padding-bottom: ${espacamento.extraPequeno}px;
    margin-top: 0;
    color: #898585;
`;

export const BordaContato = styled.div`
  flex: 1;
  border: 1px dashed #dededd;
  border-radius: ${bordaArredondar}px;
  padding: 6px;
  background-color: #f4f4f4;
  margin-bottom: ${espacamento.pequeno}px;
  position: relative;
  display: flex;
  flex-direction: column;

  svg {
    align-self: center;
    margin-left: 4px;
  }

  span {
    color: #828282;
    align-self: ${({ coluna }) => (coluna ? 'baseline' : 'center')};
  }

  b {
    align-self: ${({ coluna }) => (coluna ? 'baseline' : 'center')};
    margin-right: ${({ coluna }) => (coluna ? '0' : '10')}px;
  }

  @media screen and (max-width: 600px) {
    span {
      font-size: 0.9em;
    }
  }
`;

export const BordaContato2 = styled.div`
  flex: 1;
  border: 1px dashed #dededd;
  border-radius: ${bordaArredondar}px;
  padding: 6px;
  background-color: #f4f4f4;
  margin-bottom: ${espacamento.pequeno}px;
  position: relative;
  display: flex;
  flex-direction: column;

  svg {
    margin-left: 4px;
  }

  span {
    color: #828282;
    align-self: center;
  }

  b {
    align-self: center;
    margin-right: 10px;
  }

  @media screen and (max-width: 600px) {
    span {
      font-size: 0.9em;
    }
  }
`;

export const LinhaContato = styled.div`
  display: grid;
  flex: 1;
  
  @media screen and (min-width: 600px) {
    display: flex;
    flex-direction: ${({ coluna }) => (coluna ? 'column' : 'row')};
  }
`;

export const LinhaFormContato = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: center;

  > div {
    margin-right: 25px;
  }

  > div:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 600px) {
      flex-direction: column;
      align-items: flex-start;

      > div {
        margin-right: 0;
        margin-bottom: 12px;
      }
  }
`;
